// UserService.js
import axiosInstance from '../../api/axios';

const LabelService = {
  
  register: async (userData) => {
    try {
      const response = await axiosInstance.post('/register', userData);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Registration failed', error);
      return { success: false, error };
    }
  },

  getAllPartners: async () => {
    try {
      const response = await axiosInstance.get('/users');
      return { success: true, data: response.data.users ?? [] };
    } catch (error) {
      console.error('Failed to fetch users', error);
      return { success: false, error };
    }
  },

  updatePersonalDetails: async (userDetails) => {
    try {
      const userId = userDetails.id ?? userDetails.user_id;
      if (!userId) {
        throw new Error('User id is required to update partner details');
      }
      const response = await axiosInstance.post(`/users/${userId}`, userDetails);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to update personal details', error);
      return { success: false, error };
    }
  },

  updatePartnerDetails: async (userDetails) => {
    return LabelService.updatePersonalDetails(userDetails);
  },

  updateBankDetails: async () => {
    console.warn('Label bank details update is not supported on Accounting API');
    return { success: false, error: new Error('Not supported') };
  },

  getLabels: async () => {
    const response = await axiosInstance.get('/users/labels');
    const labels = response.data?.labels ?? [];
    if (!Array.isArray(labels)) {
      throw new Error('Invalid labels response from server');
    }
    return { success: true, data: labels };
  },

  syncLabels: async () => {
    const response = await axiosInstance.get('/labels');
    return { success: true, data: response.data };
  },

  updateLabelInvoiceRef: async ({ id, label_Inv_ref }) => {
    const response = await axiosInstance.patch(`/labels/${id}/invoice-theme`, {
      label_Inv_ref,
    });
    return { success: true, data: response.data };
  },
};

export default LabelService;